// extracted by mini-css-extract-plugin
export default {"Container":"Resources_Container__rGxsv","wrapper":"Resources_wrapper__hnz8K"};